import { useChangeLocale, usePopper, useRouter } from '@application/utils';
import beFlag from '@assets/be.svg';
import frFlag from '@assets/fr.svg';
import nlFlag from '@assets/nl.svg';
import deFlag from '@assets/de.svg';
import chFlag from '@assets/ch.svg';
import euFlag from '@assets/eu.svg';
import type { ActionsPopperData } from '@presentation/components';
import type { LocaleSwitcherData } from '@presentation/components/LocaleSwitcher';
import type { FC } from 'react';
import { useCallback, useMemo, useState } from 'react';
import type { Country, Language } from '@application/types';

interface ItemProps {
  flag: string;
  country: string;
}

const Item: FC<ItemProps> = ({ flag, country }) => (
  <>
    <img src={flag} alt="" />
    <span style={{ marginLeft: 8 }}>{country}</span>
  </>
);

// Improve this hook, better to be a component instead
export const useLocaleSwitcher = () => {
  const { language, country } = useRouter();
  const [loading, setLoading] = useState(false);

  const { changeLocale } = useChangeLocale();
  const popper = usePopper();

  const onClickHandler = useCallback(
    async (newLang: Language, newCountry: Country) => {
      setLoading(true);
      popper.close();
      await changeLocale(newLang, newCountry);
      setLoading(false);
    },
    [changeLocale, popper],
  );
  const popperItems = useMemo((): ActionsPopperData['items'] => {
    return [
      {
        onClick: () => {
          onClickHandler('fr', 'be');
        },
        label: <Item flag={beFlag} country="Belgique" />,
      },
      {
        onClick: () => {
          onClickHandler('nl', 'be');
        },
        label: <Item flag={beFlag} country="België" />,
      },
      {
        onClick: () => {
          onClickHandler('fr', 'fr');
        },
        label: <Item flag={frFlag} country="France" />,
      },
      {
        onClick: () => {
          onClickHandler('nl', 'nl');
        },
        label: <Item flag={nlFlag} country="Nederland" />,
      },
      {
        onClick: () => {
          onClickHandler('de', 'de');
        },
        label: <Item flag={deFlag} country="Deutschland" />,
      },
      {
        onClick: () => {
          onClickHandler('fr', 'ch');
        },
        label: <Item flag={chFlag} country="Suisse" />,
      },
      {
        onClick: () => {
          onClickHandler('de', 'ch');
        },
        label: <Item flag={chFlag} country="Schweiz" />,
      },
      {
        onClick: () => {
          onClickHandler('en', 'eu');
        },
        label: <Item flag={euFlag} country="English" />,
      },
      // English
      // {
      //   onClick: () => {
      //     changeLocale('en', 'de');
      //     popper.close();
      //   },
      //   label: <Item flag={deFlag} country="Germany" />,
      // },
    ];
  }, [onClickHandler]);

  const label = useMemo((): string => {
    return (
      {
        be: {
          fr: <Item flag={beFlag} country="Belgique" />,
          nl: <Item flag={beFlag} country="België" />,
        },
        fr: {
          fr: <Item flag={frFlag} country="France" />,
        },
        nl: {
          nl: <Item flag={nlFlag} country="Nederland" />,
        },
        de: {
          de: <Item flag={deFlag} country="Deutschland" />,
        },
        ch: {
          fr: <Item flag={chFlag} country="Suisse" />,
          de: <Item flag={chFlag} country="Schweiz" />,
        },
        eu: {
          en: <Item flag={euFlag} country="Europe" />,
        },
      } as any
    )[country][language];
  }, [country, language]);

  const localeClickHandler = useCallback(
    (event) => {
      popper.setTriggerElement(event.target as any);
      popper.toggle();
    },
    [popper],
  );

  return {
    props: {
      label,
      onClick: localeClickHandler,
      loading,
    } as LocaleSwitcherData,
    popperProps: {
      popper: popper.popper,
      items: popperItems,
    } as ActionsPopperData,
  };
};
